import classNames from "classnames";
import { QRCodeCanvas } from "qrcode.react";
import { forwardRef } from "react";
import styles from "../index.module.less";

/**
 * @typedef {Parameters<import('qrcode.react').QRCodeCanvas>[0]} imageSettings
 * 支付二维码
 * @param {Object} props
 * @param {String} props.id 支付地址
 * @param {String} props.host 支付地址
 * @param {path} props.path 路径
 * @param {Object} props.params 参数  {token}
 * @param {Number} props.size 二维码大小 不包括边距
 * @param {Number | String} props.padding 边距
 * @param {Object} props.style 样式
 * @param {String} props.className
 * @param {String} props.disabled 二维码失效状态
 * @param {String} props.disabledText 失效时显示的文本
 * @param {String} props.onClick 点击二维码刷新
 * @param {imageSettings} props.imageSettings 二维码中间的图片
 * @returns
 */
function RawPayQRCode(
  {
    id = "gd-pay-qrcode",
    value,
    padding = 12,
    style = {},
    size = 116,
    className = "",
    disabled = false,
    disabledText = "重新获取",
    imageSettings = {},
    onClick = () => {},
    ...rest
  },
  ref
) {
  return (
    <div
      ref={ref}
      className={classNames(styles.qrcodeWrap, className)}
      onClick={onClick}
      style={{
        padding,
        ...style,
      }}
      {...rest}
    >
      {value ? (
        <QRCodeCanvas
          id={id}
          value={value}
          size={size} // 二维码的大小
          fgColor="#000000" // 二维码的颜色
          style={{ margin: "auto" }}
          imageSettings={imageSettings}
        />
      ) : (
        <div
          style={{ display: "inline-block", width: size, height: size }}
        ></div>
      )}
      {disabled && (
        <div
          className={styles.disabledMask}
          style={{
            top: padding,
            bottom: padding,
            right: padding,
            left: padding,
          }}
        >
          <span>{disabledText}</span>
        </div>
      )}
    </div>
  );
}

const PayQRCode = forwardRef(RawPayQRCode);

export default PayQRCode;
